import Creators from './actions';
import DuckApiCalls from "../../../../utils/duckApiCalls";
import UnauthorizedError from "../../../../utils/unauthorizedError";
import moment from 'moment';

const requestTouchScreenOrdersStatsAction = Creators.requestTouchScreenOrdersStatsActions;
const receiveTouchScreenOrdersStatsAction = Creators.receiveTouchScreenOrdersStatsActions;

const getTouchScreenOrdersStats = (dateFrom, dateTo) => {
    return (dispatch, getState) => {
        dispatch(requestTouchScreenOrdersStatsAction({
            loading: true
        }));
        new DuckApiCalls().getData("reporting/touchscreenorders?from=" + moment(dateFrom).format('DD-MM-YYYY') + "&to=" + moment(dateTo).format('DD-MM-YYYY')) 
        .then(response => {
			if(response.status === 401)
				throw new UnauthorizedError(dispatch);
            return response.json()
            .then(payload => {
                dispatch(receiveTouchScreenOrdersStatsAction({
                    touchScreenOrders: payload,
                    loading: false
                }));
            });
        })
        .catch(console.error);
    };
};

export default {
    getTouchScreenOrdersStats
}